const state = {
  invites: {
    data: [],
  },
};

export default state;
